import type { ReactNode } from 'react';
import { StyleSheet, View, type StyleProp, type ViewStyle } from 'react-native';

import { ThemedText } from '@/components/themed-text';
import { Colors, Spacing } from '@/constants/theme';

interface MainPageHeaderProps {
  title: string;
  subtitle?: string;
  titleAccessory?: ReactNode;
  right?: ReactNode;
  style?: StyleProp<ViewStyle>;
}

export function MainPageHeader({
  title,
  subtitle,
  titleAccessory,
  right,
  style,
}: MainPageHeaderProps) {
  return (
    <View style={[styles.header, style]}>
      <View style={styles.copy}>
        <View style={styles.titleRow}>
          <ThemedText style={styles.title}>{title}</ThemedText>
          {titleAccessory}
        </View>
        {subtitle ? (
          <ThemedText themeColor="textSecondary" style={styles.subtitle}>
            {subtitle}
          </ThemedText>
        ) : null}
      </View>
      {right ? <View style={styles.right}>{right}</View> : null}
    </View>
  );
}

const styles = StyleSheet.create({
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: Spacing.two,
    gap: Spacing.three,
  },
  copy: { flex: 1, minWidth: 0 },
  titleRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: Spacing.one,
  },
  title: {
    color: Colors.light.text,
    fontSize: 20,
    fontWeight: '700',
    lineHeight: 26,
  },
  subtitle: {
    fontSize: 13,
    lineHeight: 18,
    marginTop: Spacing.one,
  },
  right: {
    alignItems: 'flex-end',
    justifyContent: 'center',
  },
});
